import React from 'react';
import SoldItem from './SoldItem';
import HttpClient from 'services/HttpClient';
import Pagination from 'components/purchased/Pagination';
const SOLD_REQUEST = '/api/v1/workshops/sold/?page=';
import {inject} from 'mobx-react';
import {observe} from 'mobx';

@inject('purchased')
export default class SoldList extends React.Component {

  state = {items: [], pages: 1 };

  componentDidMount = () => {
    this.props.purchased.setInitialState();
    this.request();
    this.listener = observe(this.props.purchased, 'currentPage', () => this.request());
  };

  request = () => {
    new HttpClient().get(SOLD_REQUEST + this.props.purchased.currentPage).then(data => {
      this.setState({items: data.body.data.workshops, pages: data.body.data.pages});
      this.props.purchased.setTotalPages(data.body.data.pages);
    })
  };

  componentWillUnmount = () => {
    this.listener();
  };

  render(){
    return(<main className="main-content purchased">
      <div className="container-fluid">
        <div className="dashboard row">
          {this.state.items.map( (el,i) => <SoldItem key={i} data={el}/> )}
        </div>
        {this.state.pages !== 0 &&
        <Pagination/>
        }
      </div>
    </main>)
  }
}



// WEBPACK FOOTER //
// ./src/components/sold/SoldList.jsx